export default {
  EVENTS: {
    CARDS: {
      // Fetch countries
      FETCH_COUNTRIES: 'cards.fetch_countries',
      FETCH_COUNTRIES_SUCCESS: 'cards.fetch_countries_success',
      FETCH_COUNTRIES_ERROR: 'cards.fetch_countries_error',

      // Fetch cards by country
      FETCH_BY_COUNTRY: 'cards.fetch_by_country',
      FETCH_BY_COUNTRY_SUCCESS: 'cards.fetch_by_country_success',
      FETCH_BY_COUNTRY_ERROR: 'cards.fetch_by_country_error',

      // Fetch custom cards from local API
      FETCH_CUSTOM_CARDS: 'cards.fetch_custom_cards',
      FETCH_CUSTOM_CARDS_SUCCESS: 'cards.fetch_custom_cards_success',
      FETCH_CUSTOM_CARDS_ERROR: 'cards.fetch_custom_cards_error',

      // Buy gift card
      BUY: 'cards.buy',
      BUY_SUCCESS: 'cards.buy_success',
      BUY_ERROR: 'cards.buy_error'
    }
  },
  ENDPOINTS: {
    CARDS: {
      BASE: 'https://payment.sumremit.com',
      COUNTRIES: '/gift-card/countries',
      BY_COUNTRY: '/gift-card/giftCardsByCountry/{countryCode}',
      BUY: '/gift-card/buy'
    },
    LOCAL_API: 'https://payment.sumremit.com/reloadeo-api/api',
    PARAMS: '?group=ecoxurf'
  },
  CATEGORIES: {
    PAYMENT_CARDS: { id: 1, name: 'Payment Cards', slug: 'payment-cards' },
    GAMING: { id: 3, name: 'Gaming', slug: 'gaming-cards' },
    SHOPPING: { id: 5, name: 'Shopping', slug: 'shopping-gift-cards' },
    CRYPTO: { id: 6, name: 'Crypto', slug: 'crypto-cards' },
    ENTERTAINMENT: { name: 'Entertainment', slug: 'entertainment-gift-cards' },
    LIFESTYLE: { name: 'Lifestyle', slug: 'lifestyle-cards' }
  },
  DENOMINATION_TYPES: {
    FIXED: 'FIXED',
    RANGE: 'RANGE'
  }
};
